import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    offer : [],
    loading : false,
    error : null,
};

const offerSlice = createSlice({
    name:"offer",
    initialState,
    reducers: {
        fetchOfferSuccess: (state,action) => {
            state.loading = false;
            state.offer = action.payload
        },
        fetchOfferFailure: (state,action) => {
            state.loading = false;
            state.error = action.payload
        }
    }
})

export const {
    fetchOfferSuccess,
    fetchOfferFailure
} = offerSlice.actions

export default offerSlice.reducer